import algoliasearch from 'algoliasearch';
import { Configure, Index, InstantSearch } from 'react-instantsearch-dom';
import useIsMobile from 'hooks/utils/useIsMobile';
import styles from './search.module.scss';
import CustomSearchBox from './searchBox/searchBox';
import CustomProductStateResults from './productSearch/productStateResults';
import CustomGeneralStateResults from './information/generalStateResults/generalStateResults';

const PageSearch = ({ locale, resources }) => {
  const isMobile = useIsMobile();

  const productIndex = `MAIN_${locale.toUpperCase()}_PRODUCTS`;
  const generalIndex = `MAIN_${locale.toUpperCase()}_GENERALS`;

  const appId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID;
  const apiKey = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY;

  const algoliaClient = algoliasearch(appId, apiKey);

  const searchClient = {
    search(requests) {
      if (requests.every(({ params }) => !params.query)) {
        // do not execute empty request
        return;
      }
      // eslint-disable-next-line consistent-return
      return algoliaClient.search(requests);
    },
  };

  return (
    <div className={styles.searchPageWrapper}>
      <InstantSearch indexName={productIndex} searchClient={searchClient}>
        <CustomSearchBox globals={resources} />
        <div className={styles.searchWrapper}>
          <Index indexName={productIndex}>
            <Configure hitsPerPage={isMobile ? 4 : undefined} filters="NOT algoliaIgnore=1" />
            <CustomProductStateResults locale={locale} globals={resources} />
          </Index>
          <Index indexName={generalIndex}>
            <Configure hitsPerPage={10} filters="NOT algoliaIgnore=1" />
            <CustomGeneralStateResults locale={locale} globals={resources} />
          </Index>
        </div>
      </InstantSearch>
    </div>
  );
};

export default PageSearch;
